<template>
  <el-card class="page-container">
    <h1 class="title-biaoti">主播任务完成明细</h1>
    <el-row :gutter="20" class="user-options">
      <el-col :span="6">
        <el-date-picker
          v-model="platformData"
          type="daterange"
          align="right"
          unlink-panels
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="retainedOptions"
          value-format="yyyy-MM-dd"
        >
        </el-date-picker>
      </el-col>

      <el-col :span="3">
        <el-input v-model="hostRid" placeholder="主播id"></el-input>
      </el-col>

      <el-col :span="3">

        <el-select
          filterable
          style="width: 160px"
          v-model="taskName"
          placeholder="选择任务名"
        >
          <el-option
            v-for="(item, itemIndex) in taskNameList"
            v-bind:key="itemIndex + 99"
            :label="item.taskName"
            :value="item.taskName"
          ></el-option>
        </el-select>
      </el-col>

      <el-col :span="6">
        <el-button type="warning" @click="getDayChatDetai" :loading="login1">
          查询
        </el-button>
        <el-button type="success" @click="dwnDayChatDetai" :loading="login2">
          下载
        </el-button>
      </el-col>
    </el-row>
    <el-row class="user-options">
      <el-table
        :data="dayChatDetailData"
        v-loading="login1"
        height="70vh"
        stripe
        border
      >
        <el-table-column prop="curDate" fixed label="日期" >
        </el-table-column>
        <el-table-column prop="rid" label="主播ID" >
        </el-table-column>
        <el-table-column prop="agent" label="代理" >
        </el-table-column>
        <el-table-column prop="country" label="国家" >
        </el-table-column>
        <el-table-column prop="taskName" label="任务名" >
        </el-table-column>
        <el-table-column prop="rewardCount" label="任务奖励次数" >
        </el-table-column>
        <el-table-column prop="reward" label="奖励金币数" >
        </el-table-column>
      </el-table>
    </el-row>

    <el-row class="user-options">
      <el-pagination
        :current-page.sync="page"
        layout="total, prev, pager, next"
        background
        @current-change="handleCurrentChange"
        :total="total"
        class="pagination"
        :page-size="30"
      ></el-pagination>
    </el-row>
  </el-card>
</template>

<script>
import download from '@/utils/download.js'
import { datainfor } from '@/utils/formdata.js'
import { getTaskConfig } from '@/utils/normalApi.js'

export default {
  data() {
    return {
      // 加载
      login1: false,
      login2: false,
      // 用户id白名单 MultipartFile文件
      ridFile: '',
      // 代理名或者代理id
      agentName: '',
      // 通话日期
      platformData: [datainfor(1), datainfor(1)],
      retainedOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now()
        }
      },
      // 分引
      page: 1,
      total: 0,
      // 表格数据
      dayChatDetailData: [],
      hostRid: '',
      taskName: 'all',
      language: 'all',
      languageList: [],
      isLive: -1,
      exposurePosition: 'discover',
      taskNameList: []
    }
  },
  async created() {
    this.getDayChatDetai()
    this._getTaskConfig()
  },
  methods: {
    // 查询列表
    async getDayChatDetai() {
      this.login1 = true
      const { data: res } = await this.$axios({
        type: 'GET',
        url: this.$store.getters.path.reports_task_completed,
        withCredentials: true,
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
          start: this.platformData[0],
          end: this.platformData[1],
          page: this.page,
          taskName: this.taskName,
          rid: this.hostRid
        }
      })
      this.login1 = false
      if (res.code != 0) return this.$message(res.msg)
      this.dayChatDetailData = res.data.data
      this.total = res.data.total
    },
    // 下载
    async dwnDayChatDetai() {
      this.login2 = true
      const res = await this.$axios({
        method: 'GET',
        url: this.$store.getters.path.download_task_completed,
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json'
        },
        responseType: 'blob',
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
          start: this.platformData[0],
          end: this.platformData[1],
          page: this.page,
          taskName: this.taskName,
          rid: this.hostRid
        }
      })

      this.$message.success('开始下载')
      this.login2 = false
      download(res.data, '主播任务完成明细' + this.platformData[1])
    },
    // 分页
    handleCurrentChange() {
      this.getDayChatDetai()
    },
    async _getTaskConfig() {
      const res = await getTaskConfig()
      this.taskNameList = [{taskName:'all'},...res]
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '../../assets/stylus/variable.styl';

.page-container {
  margin-left: 20px;
  margin-top: 20px;

  .el-col {
    display: flex;
    align-items: center;

    >div {
      margin-right: 5px;
    }
  }

  h1 {
    font-size: 28px;
    font-weight: bold;
  }

  .user-options {
    margin-top: 40px;

    button {
      margin-left: 30px;
    }
  }

  .display-type {
    margin-top: 20px;

    .line {
      width: 1440px;
      height: 700px;
    }
  }
}
</style>
